function getNativeBlockSelector(modulePath) {
	const slug = modulePath.match(/^\.\/([^/]+)\/block\.js$/)?.[1];

	return slug ? `.wp-block-global-theme-${slug}` : null;
}

export default function nativeBlocks() {
	const blockModules = import.meta.webpackContext('../../../blocks', {
		recursive: true,
		regExp: /\/block\.js$/
	});

	blockModules.keys().forEach((modulePath) => {
		const initBlock = blockModules(modulePath).default;
		const selector = getNativeBlockSelector(modulePath);

		if (!initBlock || !selector) return;

		document
			.querySelectorAll(selector)
			.forEach((block) => initBlock({block}));
	});
}
